// Front-end config for the password-gated briefs under the "Proprietary" menu.
//
// Nothing here may name a concept. This file ships in the public JS bundle, so
// nav labels, routes, and asset filenames all stay neutral ("Concept 3",
// /concept-3, concept-3-hero.jpg). The real name, the CTA headline, and the
// body copy come from server/<name>Content.js and are served only after a
// successful unlock -- see server/index.js CONCEPTS.
//
// `apiKey` must match a key in that CONCEPTS map. `aliases` are older named
// routes kept so existing links keep working; new concepts get none.
const concepts = [
  {
    apiKey: 'concept1',
    path: '/concept-1',
    aliases: ['/slidefence'],
    navLabel: 'Concept 1',
    idPrefix: 'sf',
    heroBg: '/assets/concept-1-hero.jpg'
  },
  {
    apiKey: 'concept2',
    path: '/concept-2',
    aliases: ['/hot-journal-inspection'],
    navLabel: 'Concept 2',
    idPrefix: 'hj',
    heroBg: '/assets/hero-railtracks.jpg'
  },
  {
    apiKey: 'concept3',
    path: '/concept-3',
    aliases: [],
    navLabel: 'Concept 3',
    idPrefix: 'rg',
    // TODO: swap for a concept-specific hero once artwork exists.
    heroBg: '/assets/hero-railtracks.jpg'
  },
  {
    apiKey: 'concept4',
    path: '/concept-4',
    aliases: [],
    navLabel: 'Concept 4',
    idPrefix: 'ow',
    // TODO: swap for a concept-specific hero once artwork exists.
    heroBg: '/assets/hero-railtracks.jpg'
  },
  {
    apiKey: 'concept5',
    path: '/concept-5',
    aliases: [],
    navLabel: 'Concept 5',
    idPrefix: 'ts',
    // TODO: swap for a concept-specific hero once artwork exists.
    heroBg: '/assets/hero-railtracks.jpg'
  },
  {
    apiKey: 'concept6',
    path: '/concept-6',
    aliases: [],
    navLabel: 'Concept 6',
    idPrefix: 'ss',
    // Deliberately the generic rail hero: this image is public and shows on the
    // locked gate, so a snow-specific one would give the subject away.
    heroBg: '/assets/hero-railtracks.jpg'
  }
];

export const CONCEPT_PATHS = concepts.flatMap((c) => [c.path, ...c.aliases]);

export default concepts;
